export default {
  type: "Dokumentum típusa",
};
